<script setup>
import MultiSelectComponent from "@/components/MultiSelectComponent.vue";
import useFilterOptions from "@/scripts/Devices/FilterOptions.js";
import { useStore } from "vuex";
import { onMounted } from "vue";

const store = useStore();

onMounted(() => {
  store.dispatch("devicesFilterOptions/fetchFilterOptions");
  store.commit("devices/RESET_DEVICE_QUERY");
  store.commit("devicesFilterOptions/RESET_FILTER_OPTIONS");
});

const {
  loading,
  course,
  deviceType,
  deviceClass,
  tagAppVersion,
  appVersion,
  unassignedStatus,
  provider,
  primaryCourses,
  deviceTypes,
  deviceClasses,
  sfTagAppVersions,
  sfAppVersions,
  providers,
  filterDevices,
} = useFilterOptions("totalDevices");
</script>

<template>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <form>
              <div class="card-header">
                <h3 class="card-title">FILTERS OPTIONS:</h3>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Course Name</label>
                      <MultiSelectComponent
                        v-model="course"
                        :options="primaryCourses"
                        label="name"
                        track-by="id"
                        placeholder="Select Course"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Device Type</label>
                      <MultiSelectComponent
                        v-model="deviceType"
                        :options="deviceTypes"
                        label="name"
                        track-by="id"
                        placeholder="Select Device Type"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Device Class</label>
                      <MultiSelectComponent
                        v-model="deviceClass"
                        :options="deviceClasses"
                        label="name"
                        track-by="id"
                        placeholder="Select Device Class"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Tagmarshal App Version</label>
                      <MultiSelectComponent
                        v-model="tagAppVersion"
                        :options="sfTagAppVersions"
                        label="sf_tagmarshal_app_version"
                        track-by="sf_tagmarshal_app_version"
                        placeholder="Select Tagmarshal App Version"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Scale Fusion Version</label>
                      <MultiSelectComponent
                        v-model="appVersion"
                        :options="sfAppVersions"
                        label="sf_app_version"
                        track-by="sf_app_version"
                        placeholder="Select Scale Fusion Version"
                      />
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Unassigned Devices</label>
                      <select class="form-control" v-model="unassignedStatus">
                        <option value="">Select Status</option>
                        <option value="unassigned">Unassigned</option>
                        <option value="assigned">Assigned</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Provider</label>
                      <MultiSelectComponent
                        v-model="provider"
                        :options="providers"
                        label="name"
                        track-by="id"
                        placeholder="Select Provider"
                      />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <button
                        type="button"
                        class="btn btn-block btn-success"
                        @click="filterDevices()"
                        :disabled="loading"
                      >
                        <font-awesome-icon
                          v-show="loading"
                          :icon="['fas', 'spinner']"
                          spin
                        />
                        <span v-show="!loading">Filter Devices</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
